"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorAndLabelForPowderyMildewValue = exports.powderyMildewRiskIndexLevelMap = void 0;
exports.powderyMildewRiskIndexLevelMap = {
    LOW: {
        label: 'Low',
        color: 'rgba(255, 238, 79, 1)',
        min: 0,
        max: 35,
    },
    MODERATE: {
        label: 'Moderate',
        color: 'rgba(254, 148, 2, 1)',
        min: 35.1,
        max: 55,
    },
    HIGH: {
        label: 'High',
        color: 'rgba(229, 53, 0, 1)',
        min: 55.1,
        max: 100,
    },
};
const getColorAndLabelForPowderyMildewValue = (value) => {
    if (value === null) {
        return {
            color: null,
            value: null,
        };
    }
    if (value > exports.powderyMildewRiskIndexLevelMap.HIGH.min) {
        return {
            color: exports.powderyMildewRiskIndexLevelMap.HIGH.color,
            value: exports.powderyMildewRiskIndexLevelMap.HIGH.label,
        };
    }
    if (value > exports.powderyMildewRiskIndexLevelMap.MODERATE.min) {
        return {
            color: exports.powderyMildewRiskIndexLevelMap.MODERATE.color,
            value: exports.powderyMildewRiskIndexLevelMap.MODERATE.label,
        };
    }
    return {
        color: exports.powderyMildewRiskIndexLevelMap.LOW.color,
        value: exports.powderyMildewRiskIndexLevelMap.LOW.label,
    };
};
exports.getColorAndLabelForPowderyMildewValue = getColorAndLabelForPowderyMildewValue;
//# sourceMappingURL=index.js.map